export function getDetailedMessage(msg) {
    switch (msg) {
        case "400":
            msg = msg + " - Bad Request. The server cannot or will not process the request due to something that is perceived to be a client error (e.g., malformed request syntax, invalid request message framing, or deceptive request routing).";
            break;
        case "401":
            msg = msg + " - Unauthorized. The request has not been applied because it lacks valid authentication credentials for the target resource.";
            break;
        case "403":
            msg = msg + " - Forbidden. The server understood the request but refuses to authorize it.";
            break;
        case "404":
            msg = msg + " - Not Found. The origin server did not find a current representation for the target resource or is not willing to disclose that one exists.";
            break;
        case "500":
            msg = msg + " - Internal Server Error. The server encountered an unexpected condition that prevented it from fulfilling the request.";
            break;
        case "502":
            msg = msg + " - Bad Gateway. The server, while acting as a gateway or proxy, received an invalid response from an inbound server it accessed while attempting to fulfill the request.";
            break;
        case "503":
            msg = msg + " - Service Unavailable. The server is currently unable to handle the request due to a temporary overload or scheduled maintenance, which will likely be alleviated after some delay. ";
            break;
        case "504":
            msg = msg + " - Gateway Timeout. The server, while acting as a gateway or proxy, did not receive a timely response from an upstream server it needed to access in order to complete the request.";
            break;
        default:
            break;
    }
    return msg;
}
